// Visit The Stimulus Handbook for more details 
// https://stimulusjs.org/handbook/introduction
// 
// This example controller works with specially annotated HTML like:
//
// <div data-controller="demo-account">
//   <h1 data-target="demo-account.output"></h1>
// </div>

import { Controller } from "stimulus"
import React, { StrictMode } from 'react';
import DemoAccount from "../src/pages/demo_account";
import { render } from 'react-dom';

export default class extends Controller {
  static values = {
    email: String,
    smsConsentText: String,
    userId: Number,
    plan: String
  };

  connect() {
    const container = document.getElementById('demo-app');
    const { emailValue, smsConsentTextValue, userIdValue, planValue } = this;

    render(<DemoAccount email={emailValue} smsConsentText={smsConsentTextValue} userId={userIdValue} plan={planValue} />, container);
  }
}



// WEBPACK FOOTER //
// ./app/javascript/controllers/demo_account_controller.js